<template>
  <v-container class="white pa-0" fluid>
    <!-- <v-row class="text-center px-0 "> -->
      <!-- ряд 1  -->
      <section-one></section-one>
      
      <!-- ряд 2  -->
      <section-two></section-two>

      <!-- ряд 3 -->
      <section-three></section-three>

      <!-- ряд 4 -->
      <section-four></section-four>

      <!-- ряд 5 -->
      <section-five></section-five>

      

      <!-- ряд 6 -->
      <!-- <v-row class="text-center px-0"> -->
        <v-col class="grey lighten-2 mb-0 pb-5 " cols="12">
          <div dark class="grey lighten-2 hidden-sm-and-down" style="height: 70px"></div>
          <div dark class="grey lighten-2 hidden-md-and-up" style="height: 25px"></div>
          <h2
            class="grey lighten-2 headline font-weight-bold px-4 mb-3 other-element"
            style="letter-spacing: 0.13125em !important; color: #616161"
          >
            ГДЕ МЫ
          </h2>
          <v-divider
            class="grey darken-2 mx-auto"
            light
            style="min-height: 3px; max-width: 50px; "
          ></v-divider>
          <div class="grey lighten-2" style="height: 40px"></div>

          <v-row justify="center" no-gutters>
            <!-- ряд 5 сектор 1 -->
            <v-col
              class="grey lighten-2 px-1 col-md-5 offset-md-0 col-12 offset-0"
            >
              <div
                class="mx-3 my-3"
              >
              <v-card  class="#597da3 justify-center align-center text-center" >
                <v-card-title
                  class="textTimelineHeaders textWordBreak justify-center "
                  style="color: white; background-color: #597da3;"
                >
                <!-- 616161 -->
                <a target="blank" class="white--text text-decoration-none"  href="https://vk.com/pravo_na_zhiznye">
                <strong>В</strong>Контакте</a>
                </v-card-title>
                  <div class="justify-center align-center text-center">
                    <vk-comment></vk-comment>
                  </div>
              </v-card>
              </div>
            </v-col>

              <!-- ряд 5 сектор 2 -->
            <v-col
              class="grey lighten-2 px-1 col-md-5 offset-md-0 col-12 offset-0"
            >
              <div
                class="mx-3 my-3"
              >
                <v-card class="teal justify-center align-center text-center" >
                  <v-card-title
                    class=" textTimelineHeaders textWordBreak justify-center"
                    style="color: white"
                  >
                    <strong>В</strong> Полоцке
                  </v-card-title>
                  <div class="justify-center align-center text-center">
                    <y-map></y-map>
                  </div>
                </v-card>
              </div>
            </v-col>
          </v-row>
          <div dark class="grey lighten-2 hidden-sm-and-down" style="height: 100px"></div>
          <div dark class="grey lighten-2 hidden-md-and-up" style="height: 30px"></div>
        </v-col>
      <!-- </v-row> -->
        
        <!-- ряд 7 -->
        <section-need-help></section-need-help>



    <!-- </v-row> -->


  </v-container>
</template>



<script>
import SectionOne from "../components/SectionOne.vue";
import SectionTwo from "../components/SectionTwo.vue";
import SectionThree from "../components/SectionThird.vue";
import SectionFour from "../components/SectionFour.vue";
import SectionFive from "../components/SectionFifth.vue";
import SectionNeedHelp from "../components/SectionNeedHelp.vue";
import YMap from "./Map.vue";
import VkComment from "../components/VkComment.vue";
export default {
  name: "HelloWorld",
  data() {
    return {
      
    };
  },

  components: {
    SectionOne,
    SectionTwo,
    SectionThree,
    SectionFour,
    SectionFive,
    SectionNeedHelp,
    YMap,
    VkComment,
  },
};
</script>

<style >
.textWordBreak {
  word-break: break-word !important;
  white-space: normal !important;
}

.textMainPage {
  letter-spacing: 0.13125em !important;
  font-size: 1.155rem !important;
  line-height: 1.5rem;
}

.textTimelineHeaders {
  letter-spacing: 0.13125em !important;
  font-size: 1.255rem !important;
  line-height: 1.5rem;
}

.textTimelines {
  letter-spacing: 0.13125em !important;
  font-size: 0.855rem !important;
  line-height: 1.2rem;
  word-break: break-word !important;
  white-space: normal !important;
}

.btnStyle {
  letter-spacing: 0.13125em !important;
  font-size: 1.155rem !important;
  line-height: 1.5rem;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.textColor {
  color: #616161
}

</style>
